import Vue from 'vue';
import Vuetify from 'vuetify';

Vue.use(Vuetify);

const options = {
  theme: {
    dark: false,
    options: { customProperties: true },
  },
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  }
};

export default new Vuetify(options);
